import { Container, ResourceIndicator } from '@bit/ui-common.ui-components/ss-components';
import { commonData, HelpLayout } from '@bit/ui-common.ui-components/ss-common-data';
import { ssFormServices, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { AfspLayout } from '@bit/ui-common.ui-components/afsp';

const
{ setEnvPrefix, getPathParams } = ssCommonUtils,
imagesPath = '/home/images',
layout = {
    bgc: '#e6e6e6',
    controlType: 'login-home',
    size: { header: 'sm', footer: 'xs' },
    images: {
        usePathname: false,
        logo: setEnvPrefix(`${imagesPath}/dhs-logo-01.png`),
        user: setEnvPrefix(`${imagesPath}/user-icon-01.png`),
        backgroundImage: setEnvPrefix(`${imagesPath}/home-image-full.jpg`)
    }
};

export default Container({
    state: ({ commonData }) => ({ commonData }),
    services: [
        ssFormServices,
        commonData.commonDataServices
    ]
},
class extends React.Component {
    constructor(props) {
        super(props);
        const { services } = props;
        services.fetchTextData();
        services.fetchGeoData();
        services.fetchLookupData();
    }

    render() {
        const { commonData: { textData, geoData, lookupData }} = this.props;
        var tab ='NEW',
        params = getPathParams();

        if (params !=null && params.tab != null) {
            tab=params.tab;
        }

        return (
            <div>
                <ResourceIndicator resources={{ textData, geoData, lookupData }} />
                <AfspLayout {...layout}>
                    <HelpLayout
                        menuFull
                        format='home-page'
                        space='home-page'
                        theme='dark'
                        defaultTab={tab}
                        portal='c'
                    />
                </AfspLayout>
            </div>
        )
    }
});
